<template>
  <div>
    <v-snackbar
      v-for="(snackbar, index) in this.snackbars"
      :key="index + Math.random()"
      :value="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :style="`top: ${(index * 60) + 8}px`"
      top
      right
      transition="slide-y-transition"
      @input="removeSnackbar(snackbar)"
    >
      <div class="font-weight-medium">{{snackbar.text}}</div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="removeSnackbar(snackbar)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
//TODO:https://codesandbox.io/s/queable-snackbars-notification-ykzxv?file=/src/components/NotificationSnackbarsWrapper.vue
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      polling: null
    };
  },
  methods: {
    ...mapActions("snackbar", ["ActionRemoveSnackbar"]),
    removeSnackbar(snackbar) {
      this.ActionRemoveSnackbar(snackbar);
    }
  },
  computed: {
    ...mapState("snackbar", ["snackbars"])
  }
};
</script>